import { useFileDownload } from 'src/hooks/useFileDownload'

import ActionButton from './ActionButton'

const FileDownload = ({
  button,
  fileName = 'export',
  label,
  url,
  query = {},
}) => {
  const { download, loading } = useFileDownload()

  const onClick = () => download({ url, fileName, query })

  return typeof button === 'function' ? (
    button(loading, onClick)
  ) : (
    <ActionButton
      busy={loading}
      icon='download'
      onClick={onClick}
      label={label}
      title={label}
    />
  )
}

export default FileDownload
